import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
//CSS Imports
import './BrandStore/styles/reset.css';
import './BrandStore/styles/common.css';

import LineLoader from './BrandStore/components/atoms/LineLoader';
import { ScrollToTop } from './BrandStore/components/atoms';
import Navigation from './BrandStore/components/pages/Navigation';


const LeadForm = lazy(() => import('./LeadForm/components/LeadForm/LeadForm'));
const Wyndham = lazy(() => import('./BrandStore/components/pages/Brand/Wyndham'));
const HowardJohnson = lazy(() => import('./BrandStore/components/pages/SubBrand/HowardJohnson'));
const Ramada = lazy(() => import('./BrandStore/components/pages/SubBrand/Ramada'));
const HawthornSuites = lazy(() => import('./BrandStore/components/pages/SubBrand/HawthornSuites'));
const DaysInn = lazy(() => import('./BrandStore/components/pages/SubBrand/DaysInn'));
const WyndhamSubBrand = lazy(() => import('./BrandStore/components/pages/SubBrand/WyndhamSubBrand'));

const TheFern = lazy(() => import('./BrandStore/components/pages/Brand/TheFern'));
const TheFernSubBrand = lazy(() => import('./BrandStore/components/pages/SubBrand/TheFern/TheFernSubBrand'));
const Beacon = lazy(() => import('./BrandStore/components/pages/SubBrand/TheFern/Beacon'));
const ZincJourney = lazy(() => import('./BrandStore/components/pages/SubBrand/TheFern/ZincJourney'));

const Inde = lazy(() => import('./BrandStore/components/pages/Brand/Inde'));

const CGHEarth = lazy(() => import('./BrandStore/components/pages/Brand/CGHEarth'));
const CGHEarthExperienceHotels = lazy(() => import('./BrandStore/components/pages/SubBrand/CGH/CGHEarthExperienceHotels'));
const CGHEarthWellness = lazy(() => import('./BrandStore/components/pages/SubBrand/CGH/CGHEarthWellness'));
const CGHEarthSaha = lazy(() => import('./BrandStore/components/pages/SubBrand/CGH/CGHEarthSaha'));

const DLSHotels = lazy(() => import('./BrandStore/components/pages/Brand/DLSHotels'));
const WelcomHeritage = lazy(() => import('./BrandStore/components/pages/Brand/WelcomHeritage'));

const TheClarks = lazy(() => import('./BrandStore/components/pages/Brand/TheClarks'));
const ClarksCollection = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/ClarksCollection'));
const ClarksExotica = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/ClarksExotica'));
const ClarksInn = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/ClarksInn'));
const ClarksInnExpress = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/ClarksInnExpress'));
const ClarksInnSuites = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/ClarksInnSuites'));
const ClarksSafari = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/ClarksSafari'));
const TheClarksSubBrand = lazy(() => import('./BrandStore/components/pages/SubBrand/TheClarks/TheClarksSubBrand'));

const LemonTreeHotel = lazy(() => import('./BrandStore/components/pages/Brand/LemonTreeHotel'));
const Aurika = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/Aurika'));
const LemonTreePremier = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/LemonTreePremier'));
const LemonTreeHotels = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/LemonTreeHotels'));
const RedFoxHotels = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/RedFoxHotels'));
const KeysSelectHotels = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/KeysSelectHotels'));
const KeysPrima = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/KeysPrima'));
const KeysLite = lazy(() => import('./BrandStore/components/pages/SubBrand/LemonTreeHotel/KeysLite'));

const Cygnett = lazy(() => import('./BrandStore/components/pages/Brand/Cygnett'));
const CygnettInn = lazy(() => import('./BrandStore/components/pages/SubBrand/Cygnett/CygnettInn'));
const CygnettStyle = lazy(() => import('./BrandStore/components/pages/SubBrand/Cygnett/CygnettStyle'));
const Cozzet = lazy(() => import('./BrandStore/components/pages/SubBrand/Cygnett/Cozzet'));

const SaffronStays = lazy(() => import('./BrandStore/components/pages/Brand/SaffronStays'));

const Sarovar = lazy(() => import('./BrandStore/components/pages/Brand/Sarovar'));
const GoldenTulip = lazy(() => import('./BrandStore/components/pages/SubBrand/Sarovar/GoldenTulip'));
const Hometel = lazy(() => import('./BrandStore/components/pages/SubBrand/Sarovar/Hometel'));
const RoyalTulip = lazy(() => import('./BrandStore/components/pages/SubBrand/Sarovar/RoyalTulip'));
const SarovarPortico = lazy(() => import('./BrandStore/components/pages/SubBrand/Sarovar/SarovarPortico'));
const SarovarPremiere = lazy(() => import('./BrandStore/components/pages/SubBrand/Sarovar/SarovarPremiere'));
const TulipInn = lazy(() => import('./BrandStore/components/pages/SubBrand/Sarovar/TulipInn'));

const IHG = lazy(() => import('./BrandStore/components/pages/Brand/IHG'));
const Kimpton = lazy(() => import('./BrandStore/components/pages/SubBrand/IHG/Kimpton'));
const Intercontinental = lazy(() => import('./BrandStore/components/pages/SubBrand/IHG/Intercontinental'));
const HolidayInn = lazy(() => import('./BrandStore/components/pages/SubBrand/IHG/HolidayInn'));
const Voco = lazy(() => import('./BrandStore/components/pages/SubBrand/IHG/Voco'));
const HotelIndigo = lazy(() => import('./BrandStore/components/pages/SubBrand/IHG/HotelIndigo'));

const Brij = lazy(() => import('./BrandStore/components/pages/Brand/Brij'));

const PoloTowers = lazy(() => import('./BrandStore/components/pages/Brand/PoloTowers'));

const Tamara = lazy(() => import('./BrandStore/components/pages/Brand/Tamara'));
const TamaraResort = lazy(() => import('./BrandStore/components/pages/SubBrand/Tamara/TamaraResort'));
const OByTamara = lazy(() => import('./BrandStore/components/pages/SubBrand/Tamara/OByTamara'));
const LilacHotel = lazy(() => import('./BrandStore/components/pages/SubBrand/Tamara/LilacHotel'));

const PalazzoVersace = lazy(() => import('./BrandStore/components/pages/Brand/PalazzoVersace'));

const LeRoi = lazy(() => import('./BrandStore/components/pages/Brand/LeRoi'));

const Kingston = lazy(() => import('./BrandStore/components/pages/Brand/Kingston'));

const Timbertale = lazy(() => import('./BrandStore/components/pages/Brand/Timbertale'));

const Emirates = lazy(() => import('./BrandStore/components/pages/FlightBrand/Emirates'));
const Cathay = lazy(() => import('./BrandStore/components/pages/FlightBrand/Cathay'));
const AirAsia = lazy(() => import('./BrandStore/components/pages/FlightBrand/AirAsia'));
const Malaysian = lazy(() => import('./BrandStore/components/pages/FlightBrand/Malaysian'));
const BestWestern = lazy(() => import('./BrandStore/components/pages/Brand/BestWestern'));
const Business = lazy(() => import('./BrandStore/components/pages/SubBrand/BestWestern/Business'));
const Leisure = lazy(() => import('./BrandStore/components/pages/SubBrand/BestWestern/Leisure'));
const Pilgrimage = lazy(() => import('./BrandStore/components/pages/SubBrand/BestWestern/Pilgrimage'));
const BestWesternBasic = lazy(() => import('./BrandStore/components/pages/SubBrand/BestWestern/BestWesternBasic'));
const BestWesternPlus = lazy(() => import('./BrandStore/components/pages/SubBrand/BestWestern/BestWesternPlus'));
const SureStay = lazy(() => import('./BrandStore/components/pages/SubBrand/BestWestern/SureStay'));

const Ascott = lazy(() => import('./BrandStore/components/pages/Brand/Ascott'));
const CloseToMetro = lazy(() => import('./BrandStore/components/pages/SubBrand/Ascott/CloseToMetro'));
const KidFriendlyActivities = lazy(() => import('./BrandStore/components/pages/SubBrand/Ascott/KidFriendlyActivities'));
const PoolsideBliss = lazy(() => import('./BrandStore/components/pages/SubBrand/Ascott/PoolsideBliss'));

const Majestic = lazy(() => import('./BrandStore/components/pages/Brand/Majestic'));
const Etihad = lazy(() => import('./BrandStore/components/pages/FlightBrand/Etihad'));
const MalaysianPrefetch = lazy(() => import('./BrandStore/components/pages/FlightBrand/MalaysianPrefetch'));

const HongKongDisneyLand = lazy(() => import('./BrandStore/components/pages/Brand/HongKongDisneyLand'));

const Taj = lazy(() => import('./BrandStore/components/pages/Brand/Taj'));

const Sterling = lazy(() => import('./BrandStore/components/pages/Brand/Sterling'));

const Ita = lazy(() => import('./BrandStore/components/pages/FlightBrand/Ita'));
const AirIndia = lazy(() => import('./BrandStore/components/pages/FlightBrand/AirIndia'));
const AirIndiaexpress = lazy(() => import('./BrandStore/components/pages/FlightBrand/AirIndiaexpress'));
const Quantas = lazy(() => import('./BrandStore/components/pages/FlightBrand/Quantas'));
const Thankyou = lazy(() => import('./BrandStore/components/pages/FlightBrand/Thankyou'));
function MMTHomePageRedirect() {
	const hostname = window.location.hostname;

	useEffect(() => {
		if (hostname === 'brands.goibibo.com') {
			window.location.replace('https://www.goibibo.com/');
		} else {
			window.location.replace('https://www.makemytrip.com/');
		}
	}, []);
	return null;
}

const App = () => {
	return (
		<Router>
			<ScrollToTop />
			<Suspense fallback={<LineLoader />}>
				<Routes>
					<Route exact path="/" element={<MMTHomePageRedirect />} />
					<Route exact path="/BrandStores" element={<Navigation />} />
					<Route exact path="/LeadGen" element={<LeadForm />} />
					<Route exact path="/Wyndham" element={<Wyndham />} />
					<Route exact path="/Wyndham/HowardJohnson" element={<HowardJohnson />} />
					<Route exact path="/Wyndham/Ramada" element={<Ramada />} />
					<Route exact path="/Wyndham/HawthornSuites" element={<HawthornSuites />} />
					<Route exact path="/Wyndham/DaysInn" element={<DaysInn />} />
					<Route exact path="/Wyndham/WyndhamHotels" element={<WyndhamSubBrand />} />
					<Route path="/TheFern" element={<TheFern />} />
					<Route path="/TheFern/TheFernSubBrand" element={<TheFernSubBrand />} />
					<Route path="/TheFern/Beacon" element={<Beacon />} />
					<Route path="/TheFern/ZincJourney" element={<ZincJourney />} />
					<Route path="/Inde" element={<Inde />} />
					<Route path="/CGHEarth" element={<CGHEarth />} />
					<Route path="/CGHEarth/CGHEarthExperienceHotels" element={<CGHEarthExperienceHotels />} />
					<Route path="/CGHEarth/CGHEarthWellness" element={<CGHEarthWellness />} />
					<Route path="/CGHEarth/CGHEarthSaha" element={<CGHEarthSaha />} />
					<Route path="/DLSHotels" element={<DLSHotels />} />
					<Route path="/WelcomHeritage" element={<WelcomHeritage />} />
					<Route path="/TheClarks" element={<TheClarks />} />
					<Route path="/TheClarks/TheClarksSubBrand" element={<TheClarksSubBrand />} />
					<Route path="/TheClarks/ClarksCollection" element={<ClarksCollection />} />
					<Route path="/TheClarks/ClarksExotica" element={<ClarksExotica />} />
					<Route path="/TheClarks/ClarksInn" element={<ClarksInn />} />
					<Route path="/TheClarks/ClarksInnExpress" element={<ClarksInnExpress />} />
					<Route path="/TheClarks/ClarksInnSuites" element={<ClarksInnSuites />} />
					<Route path="/TheClarks/ClarksSafari" element={<ClarksSafari />} />
					<Route path="/LemonTreeHotel" element={<LemonTreeHotel />} />
					<Route path="/LemonTreeHotel/Aurika" element={<Aurika />} />
					<Route path="/LemonTreeHotel/LemonTreePremier" element={<LemonTreePremier />} />
					<Route path="/LemonTreeHotel/LemonTreeHotels" element={<LemonTreeHotels />} />
					<Route path="/LemonTreeHotel/RedFoxHotels" element={<RedFoxHotels />} />
					<Route path="/LemonTreeHotel/KeysSelectHotels" element={<KeysSelectHotels />} />
					<Route path="/LemonTreeHotel/KeysPrima" element={<KeysPrima />} />
					<Route path="/LemonTreeHotel/KeysLite" element={<KeysLite />} />
					<Route path="/CygnettHotels&Resorts" element={<Cygnett />} />
					<Route path="/CygnettHotels&Resorts/CygnettInn" element={<CygnettInn />} />
					<Route path="/CygnettHotels&Resorts/CygnettStyle" element={<CygnettStyle />} />
					<Route path="/CygnettHotels&Resorts/CozzetHotels" element={<Cozzet />} />
					<Route path="/SaffronStays" element={<SaffronStays />} />
					<Route path="/Sarovar" element={<Sarovar />} />
					<Route path="/Sarovar/GoldenTulip" element={<GoldenTulip />} />
					<Route path="/Sarovar/Hometel" element={<Hometel />} />
					<Route path="/Sarovar/RoyalTulip" element={<RoyalTulip />} />
					<Route path="/Sarovar/SarovarPortico" element={<SarovarPortico />} />
					<Route path="/Sarovar/SarovarPremiere" element={<SarovarPremiere />} />
					<Route path="/Sarovar/TulipInn" element={<TulipInn />} />
					<Route path="/IHG" element={<IHG />} />
					<Route path="/IHG/Kimpton" element={<Kimpton />} />
					<Route path="/IHG/Intercontinental" element={<Intercontinental />} />
					<Route path="/IHG/HolidayInn" element={<HolidayInn />} />
					<Route path="/IHG/Voco" element={<Voco />} />
					<Route path="/IHG/HotelIndigo" element={<HotelIndigo />} />
					<Route path="/Brij" element={<Brij />} />
					<Route path="/PoloTowers" element={<PoloTowers />} />
					<Route path="/Tamara" element={<Tamara />} />
					<Route path="/Tamara/TamaraResort" element={<TamaraResort />} />
					<Route path="/Tamara/OByTamara" element={<OByTamara />} />
					<Route path="/Tamara/LilacHotel" element={<LilacHotel />} />
					<Route path="/PalazzoVersace" element={<PalazzoVersace />} />
					<Route path="/LeRoi" element={<LeRoi />} />
					<Route path="/Kingston" element={<Kingston />} />
					<Route path="/Timbertale" element={<Timbertale />} />
					<Route path="/BestWestern" element={<BestWestern />} />
					<Route path="/BestWestern/Business" element={<Business />} />
					<Route path="/BestWestern/Leisure" element={<Leisure />} />
					<Route path="/BestWestern/Pilgrimage" element={<Pilgrimage />} />
					<Route path="/BestWestern/BestWesternBasic" element={<BestWesternBasic />} />
					<Route path="/BestWestern/BestWesternPlus" element={<BestWesternPlus />} />
					<Route path="/BestWestern/SureStay" element={<SureStay />} />
					<Route path="/Emirates" element={<Emirates />} />
					<Route path="/Ascott" element={<Ascott />} />
					<Route path="/Ascott/CloseToMetro" element={<CloseToMetro />} />
					<Route path="/Ascott/KidFriendlyActivities" element={<KidFriendlyActivities />} />
					<Route path="/Ascott/PoolsideBliss" element={<PoolsideBliss />} />
					<Route path="/flight/Cathay" element={<Cathay />} />
					<Route path="/flight/AirAsia" element={<AirAsia />} />
					<Route path="/flight/malaysiaairlines" element={<Malaysian />} />
					<Route path="/Majestic" element={<Majestic />} />
					<Route path="/flight/Etihad" element={<Etihad />} />
					<Route path="/HongKongDisneyLand" element={<HongKongDisneyLand />} />
					<Route path="/Taj" element={<Taj />} />
					<Route path="/Sterling" element={<Sterling />} />
					<Route path="/flight/MalaysianPrefetch" element={<MalaysianPrefetch />} />
					<Route path="/flight/itaairways" element={<Ita />} />
					<Route path="/flight/airindia" element={<AirIndia />} />
					<Route path="/flight/airindiaexpress" element={<AirIndiaexpress />} />
					<Route path="/flight/test/thankyou" element={<Thankyou />} />
					<Route path="/flight/Qantas" element={<Quantas />} />
				</Routes>
			</Suspense>
		</Router>
	);
};

export default App;
